module.exports = __webpack_public_path__ + "img/Augur White Horizontal.068a8abd.svg";